import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/shutdown/reason`,
    name: 'SHUTDOWN_REASON_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
